<template>
  <div class="form-control-static">
    <router-link :to="to" style="display: inline-block">{{link.label}}</router-link>
  </div>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-link',
    mixins: [mixin],
    components: {},
    computed: {
      link() {
        return this.spec.link || {};
      },
      to() {
        if (typeof this.link.to === 'function') {
          return this.link.to.call(this, this.value, this.model, this.spec);
        } else {
          return this.link.to;
        }
      },
    },
    methods: {},
  };
</script>



// WEBPACK FOOTER //
// f-link.vue?24a81c7f